import { Product } from '../types'

export const mainCategories = ['Men', 'Women', 'Kids']

export const categories = ['All', 'Men', 'Women', 'Kids']

export const subCategories: Record<string, string[]> = {
  Men: ['T-Shirts', 'Shirts', 'Jeans', 'Kurtas', 'Jackets'],
  Women: ['Tops', 'Dresses', 'Kurtas', 'Jeans', 'Ethnic Wear'],
  Kids: ['T-Shirts', 'Frocks', 'Shorts', 'Ethnic', 'Winter Wear'],
}

export const categoryImages: Record<string, string> = {
  Men: 'https://images.unsplash.com/photo-1617137968427-85924c800a22?w=600&q=80',
  Women:
    'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=600&q=80',
  Kids: 'https://images.unsplash.com/photo-1519238263530-99bdd11df2ea?w=600&q=80',
}

export const mockProducts: Product[] = []
